import { RouterProvider } from "react-router-dom";
import router from "./routes/index";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import { setItem } from "./lib/utils";
import type { WebAppConfig } from "./services/api/auth/auth.interface";
import AuthService from "./services/api/auth/auth";
import theme from "./theme";
import { CssBaseline } from "@mui/material";
import { DrawerProvider } from "./components/Drawer/context/DrawerContext";
import Supplier from "./pages/DistributorMerchant/SupplierManagement/Supplier/Supplier";
import DrawerContainer from "./components/Drawer/Drawer";
import { RoleProvider } from "./pages/Role/Role";
import { DistributorProvider } from "./pages/DistributorMerchant/SupplierManagement/context/DistributorIDcontext";

const App = () => {
  // useEffect(() => {
  //   const webApp = async () => {
  //     let data: WebAppConfig = await AuthService.webAppSetting();
  //     setItem("layoutConfig", data);
  //     document.title = data?.WebAppTitle;
  //   };
  //   webApp();
  // }, []);

  return (
    <RoleProvider>
       <DistributorProvider>
    <DrawerProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* <Supplier/> */}
        <DrawerContainer width="min(650px, 90vw)" />
        <RouterProvider router={router} />
      </ThemeProvider>
    </DrawerProvider>
    </DistributorProvider>

    </RoleProvider>
  );
};

export default App;
